export function WhatsAppButton() {
  const phone = "918287428256";
  const message = encodeURIComponent("Hi, I want to explore SwitchYourVendor services");
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl shadow-green-600/30 hover:scale-110 transition-transform active:scale-95"
      title="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.174 0 16c0 3.502 1.13 6.746 3.05 9.38L1.054 31.13l5.96-1.966C9.516 30.976 12.64 32 16.004 32 24.826 32 32 24.826 32 16S24.826 0 16.004 0zm9.338 22.588c-.39 1.1-1.932 2.014-3.156 2.28-.838.18-1.932.322-5.618-1.208-4.716-1.956-7.748-6.74-7.984-7.054-.226-.314-1.9-2.532-1.9-4.83s1.2-3.43 1.628-3.898c.39-.428.918-.624 1.23-.624.294 0 .584 0 .838.016.274.012.636-.104.994.758.39.936 1.318 3.226 1.434 3.462.116.236.196.508.04.82-.156.314-.236.508-.468.784-.236.274-.494.614-.704.822-.236.236-.482.49-.208.962.274.468 1.22 2.014 2.618 3.264 1.8 1.606 3.318 2.104 3.786 2.34.468.236.742.196 1.016-.118.274-.314 1.18-1.376 1.494-1.844.314-.468.628-.39 1.058-.236.428.156 2.726 1.286 3.194 1.52.468.236.78.352.896.546.118.196.118 1.12-.272 2.22z"/>
      </svg>
    </a>
  );
}
